
<template>
  <div>
    <v-card outlined v-if="uniqueAwards.length > 0">
      <v-card-text class="pa-0">
        <v-container>
          <v-row v-for="award in uniqueAwards" :key="award.code" class="pa-0">
            <v-col class="pt-0 pb-0 caption">
              <v-icon small>{{award.mdi_icon}}</v-icon>
              <span>&nbsp;=&nbsp;</span>
              <span>{{award.name}}</span>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AwardLegend",
  props: {
    // non-unique awards
    awards: {
      type: Array,
      required: true
    }
  },
  computed: {
    uniqueAwards: function() {
      let ret = [];
      let keysAdded = {};
      this.awards.forEach(award => {
        if (keysAdded[award.code] === undefined) {
          ret.push(award);
          keysAdded[award.code] = award;
        }
      });
      return ret;
    }
  }
};
</script>